import storage from "store";
import { AUTH } from "@/store/mutation-types";

export function check(authority) {
  const current = storage.get(AUTH) || [];
  return current.some(item => authority.includes(item));
}
